import { render } from "./ShirtsComponent.vue?vue&type=template&id=7861e56e&scoped=true"
import script from "./ShirtsComponent.vue?vue&type=script&lang=js"
export * from "./ShirtsComponent.vue?vue&type=script&lang=js"

import "./ShirtsComponent.vue?vue&type=style&index=0&id=7861e56e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7861e56e"]])

export default __exports__